export default "__VITE_ASSET__BSVlVgbl__"